<template>
    <div>
        <HeaderNav v-if="!isWeixinBrowser()" :beforecolor="'#000'" :backcolor="'#fff'" :showNavLine="'1'" @returnBack="goToBack"></HeaderNav>
        <div>
            <iframe style="border:none" width="100%" :height="frameHeight" v-bind:src="url"></iframe>
        </div>
    </div>
</template>

<script>
    export default {
        name: "index",
        data() {
            return {
                url: "",
                frameHeight: 300,
                frameWidth: 300,
            }
        },
        mounted() {
            window.onresize = () => {
                this.widthHeight(); // 自适应高宽度
            };
            this.$nextTick(function () {
                this.widthHeight();
            });
        },
        methods: {
            goToBack() {
                this.goBack(this.$router);
            },
            widthHeight() {
                this.frameHeight = window.innerHeight - (this.isWeixinBrowser() ? 0 : 44);
            },
            showStatusWhite:function (status) {
                let that = this;

                if (status === 0) {
                    window.scrollTo(0, 0);
                }

                let token = that.$store.state.token;
                let userid = that.$store.state.userid;

                if (that.isEmpty(token) || that.isEmpty(userid)) {
                    return;
                }

                userid = userid.toString();

                if (token.length > userid.length) {
                    if (that.isAppIos()) {
                        var vUrl = "readingclubapp:changeStatusStyle:" + status;
                        document.location = vUrl;
                    }

                    if (that.isAppAndroid()) {
                        window.note.changeStatusStyle(status);
                    }
                }
            }
        },
        created() {
            this.url = this.$route.query.url;
        },
        beforeRouteEnter(to, form, next) {
            next(vm=>{
                vm.showStatusWhite(0);
            });
        },
        beforeRouteLeave(to, form, next) {
            this.showStatusWhite(1);
            next();
        }
    }
</script>

<style scoped>
    .head {
        position: fixed;
    }
</style>
